<template>
  <div class="content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData">
      <el-table-column prop="title" label="摄像头名称"></el-table-column>
      <el-table-column prop="number" label="摄像头编号"></el-table-column>
      <el-table-column prop="name" label="所属路灯"> </el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column label="是否首页显示" prop="type">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.type"
            :active-value="1"
            :inactive-value="0"
            active-color="#67C23A"
            inactive-color="#aaaaaa"
            @change="changeSwitch(scope.row.id, scope.row.type)"
          />
        </template>
      </el-table-column>
      <el-table-column label="摄像头厂家">
        <template slot-scope="scope">
          {{camera_fac_arr[scope.row.camera_type]}}
        </template>
      </el-table-column>
      <el-table-column label="查看监控">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            class="item"
            content="查看监控"
            placement="top"
          >
            <div
              class="my-icon-button"
              @click="getOutVideo(scope.row.title, scope.row.number, scope.row.camera_type)"
            >
              <i class="el-icon-video-play"></i>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="摄像头名称" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>
          <el-form-item label="摄像头编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item label="选择厂家">
            <el-select
              popper-class="fac_h"
              placeholder="请选择厂家"
              v-model="editOne.camera_type"
              style="width: 100%;height:auto;"
            >
              <el-option
                v-for="t in facList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看设备{{ videoData.title }}监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <video-mini-control
          ref="video_con"
          :deviceSerial="videoData.vNumber"
          :accessToken="accessToken"
          :type="videoData.type"
        ></video-mini-control>
      </div>
    </div>


  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import videoMiniControl from "@/components/video/VideoMiniControl";
export default {
  components: {
    videoMiniControl,
  },
  data() {
    return {
      loading: false,
      camera_fac_arr: ['海康威视','海康威视','大华'],
      facList: [
        {
          id: 1,
          name:'海康威视'
        },
        {
          id: 2,
          name:'大华'
        }
      ],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      videoData: {
        title: "",
        vNumber: "",
        type: 1,
        dialogVisible: false,
      },
      accessToken: null,
      dialogVisible: false,
      editType: -1,
      lampList: [],
      editOne: {
        number: '',
        camera_type: 1,
        title: '',
        address: '',
        lamp_id: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightListApi.cameraList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    async getOutVideo(title, number, type) {
      this.videoData.title = title;
      this.videoData.vNumber = number
      this.videoData.type = type
      await this.videoGetAccessToken(type)
      this.videoData.dialogVisible = true
    },
    closeVideo() {
      // 关闭视频
      this.videoData.title = "";
      this.videoData.vNumber = "";
      this.videoData.type = 1;
      this.videoData.dialogVisible = false;
    },
    async videoGetAccessToken(type) {
      await lightListApi.getAccessToken({camera_type: type}).then((res) => {
        this.accessToken = res.data.accessToken
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          number: '',
          camera_type: 1,
          title: '',
          address: '',
          lamp_id: null
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          number: index.number,
          camera_type: index.camera_type,
          address: index.address,
          lamp_id: index.lamp_id
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      lightListApi.cameraEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      lightListApi.cameraAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取路灯列表
      lightListApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightListApi.cameraDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(id, value) {
      lightListApi.cameraSetHome(id,{ type: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    }

  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>

<style lang='less'>
.fac_h{
  .el-scrollbar__wrap{
    min-height:100px !important;
  }
}
</style>
